import { useAppTranslation } from '@flowus/common/i18n';
import { useBarChartStyle, useUpdateChartFormatStyle } from 'src/hooks/chart';
import { CheckboxText } from 'src/views/logoff/checkbox-text';
import { ChartLine } from '../../chart-line';
import { Input } from 'src/common/components/input';
import { useChartBlockId } from '../chart-config-context';
import type { FC } from 'react';

export const BarStyle: FC = () => {
  const chartBlockId = useChartBlockId();
  const updateChartFormatStyle = useUpdateChartFormatStyle();
  const {
    showDataLabel,
    showGridLine,
    showXAxisLabel,
    showXAxisLine,
    showXAxisCalibration,
    showYAxisLabel,
    showYAxisLine,
    showYAxisCalibration,
    xAxisTtile,
    yAxisTtile,
  } = useBarChartStyle(chartBlockId);
  const { t } = useAppTranslation();
  return (
    <>
      <div className="grid grid-cols-2 mt-4 w-full">
        <CheckboxText
          defaultChecked={showDataLabel}
          content={t('common.data_label')}
          onCheck={(checked) => {
            updateChartFormatStyle(chartBlockId, {
              showDataLabel: checked,
            });
          }}
        />
        <CheckboxText
          defaultChecked={showGridLine}
          content={t('editor.component.chart.chart_config_panel.style.bar_style.grid_line')}
          onCheck={(checked) => {
            updateChartFormatStyle(chartBlockId, {
              showGridLine: checked,
            });
          }}
        />
      </div>
      <ChartLine className="my-4" />
      <div className="text-t2-medium">
        {t('editor.component.chart.chart_config_panel.style.bar_style.horizontal_axis')}
      </div>
      <div className="grid gap-y-2 grid-cols-2  mt-4 w-full   flex-wrap">
        <CheckboxText
          defaultChecked={showXAxisLabel}
          content={t('editor.component.chart.chart_config_panel.style.bar_style.show_label')}
          onCheck={(checked) => {
            updateChartFormatStyle(chartBlockId, {
              showXAxisLabel: checked,
            });
          }}
        />
        <CheckboxText
          defaultChecked={showXAxisLine}
          content={t('editor.component.chart.chart_config_panel.style.bar_style.show_axis_line')}
          onCheck={(checked) => {
            updateChartFormatStyle(chartBlockId, {
              showXAxisLine: checked,
            });
          }}
        />
        <CheckboxText
          defaultChecked={showXAxisCalibration}
          content={t('editor.component.chart.chart_config_panel.style.bar_style.show_calibration')}
          onCheck={(checked) => {
            updateChartFormatStyle(chartBlockId, {
              showXAxisCalibration: checked,
            });
          }}
        />
      </div>
      <ChartLine className="my-4" />
      <div className="text-t2-medium">
        {t('editor.component.chart.chart_config_panel.style.bar_style.vertical_axis')}
      </div>
      <div className="grid gap-y-2 grid-cols-2  mt-4 w-full   flex-wrap">
        <CheckboxText
          defaultChecked={showYAxisLabel}
          content={t('editor.component.chart.chart_config_panel.style.bar_style.show_label')}
          onCheck={(checked) => {
            updateChartFormatStyle(chartBlockId, {
              showYAxisLabel: checked,
            });
          }}
        />
        <CheckboxText
          defaultChecked={showYAxisLine}
          content={t('editor.component.chart.chart_config_panel.style.bar_style.show_axis_line')}
          onCheck={(checked) => {
            updateChartFormatStyle(chartBlockId, {
              showYAxisLine: checked,
            });
          }}
        />
        <CheckboxText
          defaultChecked={showYAxisCalibration}
          content={t('editor.component.chart.chart_config_panel.style.bar_style.show_calibration')}
          onCheck={(checked) => {
            updateChartFormatStyle(chartBlockId, {
              showYAxisCalibration: checked,
            });
          }}
        />
      </div>
      <ChartLine className="my-4" />
      <div className="text-t2-medium">
        {t('editor.component.chart.chart_config_panel.style.bar_style.axis_title')}
      </div>
      <div className="mt-4 text-t2 flex items-center space-x-2">
        <div className="shrink-0">
          {t('editor.component.chart.chart_config_panel.style.bar_style.horizontal_axis_title')}
        </div>
        <Input
          className="text-t2 w-full h-7 bg-white1"
          value={xAxisTtile}
          focusWidthBorder={false}
          placeholder={t(
            'editor.component.chart.chart_config_panel.style.bar_style.input_title_placeholder'
          )}
          onChange={(v) => {
            updateChartFormatStyle(chartBlockId, {
              xAxisTtile: v,
            });
          }}
        />
      </div>
      <div className="text-t2 flex items-center space-x-2 mt-3">
        <div className="shrink-0">
          {t('editor.component.chart.chart_config_panel.style.bar_style.vertical_axis_title')}
        </div>
        <Input
          className="text-t2 w-full h-7 bg-white1"
          value={yAxisTtile}
          focusWidthBorder={false}
          placeholder={t(
            'editor.component.chart.chart_config_panel.style.bar_style.input_title_placeholder'
          )}
          onChange={(v) => {
            updateChartFormatStyle(chartBlockId, {
              yAxisTtile: v,
            });
          }}
        />
      </div>
    </>
  );
};
